// extracted by mini-css-extract-plugin
module.exports = {"img":"ConsignmentDocuments_img__3HQHA"};